import { Box, useSlotRecipe } from '@chakra-ui/react';
import { materialOceanic } from 'react-syntax-highlighter/dist/esm/styles/prism';
import {
  Prism as SyntaxHighlighter,
  type SyntaxHighlighterProps,
} from 'react-syntax-highlighter';

import type { ComponentProps, JSX, ReactNode, RefObject } from 'react';

import { useMarkdownContext } from '../context';
import { syntaxHighlighterRecipe } from './recipe';

export type TMetaProps = Omit<SyntaxHighlighterProps, 'children'>;

interface ISyntaxProps
  extends Omit<ComponentProps<'code'>, 'children' | 'className'> {
  meta: TMetaProps;
  language?: string;
  filename?: string;
  children: ReactNode;
}

export function Syntax({
  ref,
  meta,
  language,
  children,
  filename = '',
  ...props
}: ISyntaxProps): JSX.Element {
  const { codeBlock = {} } = useMarkdownContext();
  const { wrapLongLines } = codeBlock;
  const recipe = useSlotRecipe({
    recipe: syntaxHighlighterRecipe,
  });

  const { container } = recipe();

  const stringChildren = String(children)
    .replace(/\n$/, '')
    .replace(/&nbsp;/gm, '');

  return (
    <Box
      className='syntax'
      css={{
        ...container,
        _before: {
          content: `'${filename || ''}'`,
        },
      }}
    >
      <SyntaxHighlighter
        wrapLines
        language={language}
        wrapLongLines={wrapLongLines}
        ref={ref as unknown as RefObject<SyntaxHighlighter>}
        {...meta}
        {...props}
        style={{
          ...materialOceanic,
          'code[class*="language-"]': {
            ...materialOceanic['code[class*="language-"]'],
            width: '100%',
            display: 'block',
          },
          'pre[class*="language-"]': {
            ...materialOceanic['pre[class*="language-"]'],
            borderRadius: '0.3rem',
            padding: '2rem 1rem',
          },
        }}
      >
        {stringChildren}
      </SyntaxHighlighter>
    </Box>
  );
}
